module.exports = __webpack_public_path__ + "img/horizontal_3_5_7016.4e41a9c8.png";